<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer002">
<p class="OT"><em class="italic">Contents</em></p>
<p class="CON2" id="toc1"><a href="#/Thiselton_A_Shorter_Guide3#_idTextAnchor001">Preface</a></p>
<p class="CON2" id="toc2"><a href="#/Thiselton_A_Shorter_Guide4#_idTextAnchor002">Abbreviations</a></p>
<p class="CON1" id="toc3"><a href="#/Thiselton_A_Shorter_Guide5#_idTextAnchor004">Part I: The Spirit in the Biblical Writings</a></p>
<p class="CON2" id="toc4"><a href="#/Thiselton_A_Shorter_Guide6#_idTextAnchor005">1. The Spirit in the Old Testament</a></p>
<p class="CON2" id="toc5"><a href="#/Thiselton_A_Shorter_Guide7#_idTextAnchor170">2. The Literature of Intertestamental Judaism</a></p>
<p class="CON2" id="toc6"><a href="#/Thiselton_A_Shorter_Guide8#_idTextAnchor250">3. The Holy Spirit in the First Three Gospels</a></p>
<p class="CON2" id="toc7"><a href="#/Thiselton_A_Shorter_Guide9#_idTextAnchor367">4. The Holy Spirit in the Pauline Epistles</a></p>
<p class="CON2" id="toc8"><a href="#/Thiselton_A_Shorter_Guide10#_idTextAnchor729">5. The Holy Spirit in Acts</a></p>
<p class="CON2" id="toc9"><a href="#/Thiselton_A_Shorter_Guide11#_idTextAnchor905">6. The Holy Spirit in the Johannine Writings</a></p>
<p class="CON2" id="toc10"><a href="#/Thiselton_A_Shorter_Guide12#_idTextAnchor1049">7. The Spirit in the Rest of the New Testament</a></p>
<p class="CON1" id="toc11"><a href="#/Thiselton_A_Shorter_Guide13#_idTextAnchor1237">Part II: Doctrinal Themes</a></p>
<p class="CON2" id="toc12"><a href="#/Thiselton_A_Shorter_Guide14#_idTextAnchor1238">8. The Holy Spirit and the Trinity: <br/>The Spirit’s Shared Status with God</a></p>
<p class="CON2" id="toc13"><a href="#/Thiselton_A_Shorter_Guide15#_idTextAnchor1440">9. The Holy Spirit and Jesus Christ</a></p>
<p class="CON2" id="toc14"><a href="#/Thiselton_A_Shorter_Guide16#_idTextAnchor1512">10. The Holy Spirit and the Church</a></p>
<p class="CON2" id="toc15"><a href="#/Thiselton_A_Shorter_Guide17#_idTextAnchor1699">11. The Holy Spirit, Revelation, and Inspiration</a></p>
<p class="CON2" id="toc16"><a href="#/Thiselton_A_Shorter_Guide18#_idTextAnchor1792">12. The Holy Spirit and Sanctification</a></p>
<p class="CON2" id="toc17"><a href="#/Thiselton_A_Shorter_Guide19#_idTextAnchor1942">13. The Holy Spirit and Eschatology</a></p>
<p class="CON1" id="toc18"><a href="#/Thiselton_A_Shorter_Guide20#_idTextAnchor2109">Part III: Experience and Global Origins and <br/>Current Issues among Pentecostals</a></p>
<p class="CON2" id="toc19"><a href="#/Thiselton_A_Shorter_Guide21#_idTextAnchor2110">14. The Origin and Development of Pentecostalism</a></p>
<p class="CON2" id="toc20"><a href="#/Thiselton_A_Shorter_Guide22#_idTextAnchor2321">15. The Self-­Awareness and Diversity <br/>of Pentecostals Today</a></p>
<p class="CON2" id="toc21"><a href="#/Thiselton_A_Shorter_Guide23#_idTextAnchor2480">16. The Holy Spirit and Hermeneutics</a></p>
<p class="CON2" id="toc22"><a href="#/Thiselton_A_Shorter_Guide24#_idTextAnchor2691">17. Prayer and Worship in the Context <br/>of the Spirit and the Trinity</a></p>
<p class="CON2" id="toc23"><a href="#/Thiselton_A_Shorter_Guide25#_idTextAnchor2768">Bibliography</a></p>
<p class="CON2" id="toc24"><a href="#/Thiselton_A_Shorter_Guide26#_idTextAnchor2806">Index of Authors</a></p>
<p class="CON2" id="toc25"><a href="#/Thiselton_A_Shorter_Guide27#_idTextAnchor2808">Index of Subjects<br/>(patristic names are also included)</a></p>
<p class="CON2" id="toc26"><a href="#/Thiselton_A_Shorter_Guide28#_idTextAnchor2810">Index of Scripture and Other Ancient Sources</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Thiselton_A_Shorter_Guide-2.vue?7634fd0c